import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  Modal,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  Fade,
} from '@mui/material';

const MachineAvailabilityModal = ({ open, onClose, machine, toggleStatus }) => {
  // console.log({ machine });
  const [status, setStatus] = useState(machine?.status || 'Available');
  const [subStatus, setSubStatus] = useState(machine?.status || "");
  const [remarks, setRemarks] = useState(machine?.remarks || '');
  const [showRemarksError, setShowRemarksError] = useState(false);
  const [remarksOptions, setRemarksOptions] = useState([]);

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
    setSubStatus('');
    setRemarks('');
    setRemarksOptions([]);
  };

  const updateRemarks = (selectedSubStatus) => {
    if (selectedSubStatus === 'In Use') {
      setRemarksOptions(['In Schedule']);
    } else {
      setRemarksOptions([]);
    }
  };

  const handleSubStatusChange = (event) => {
    const selectedSubStatus = event.target.value;
    setSubStatus(selectedSubStatus);
    setRemarks('');

    updateRemarks(selectedSubStatus);
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  const handleSave = () => {
    console.log("called save", status, subStatus, remarks);
    if ((subStatus === 'Breakdown' || subStatus === 'In Use') && !remarks) {
      setShowRemarksError(true);
      return;
    }
    if (status === "Available") {
      toggleStatus(machine?.machine_id, status, remarks);
    } else {
      toggleStatus(machine?.machine_id, subStatus, remarks);
    }
    setShowRemarksError(false);
    onClose();
  };

  const handleClose = () => {
    setShowRemarksError(false);
    onClose();
  };

  useEffect(() => {
    if (open) {
      setStatus(machine?.status || "");
      setSubStatus(machine?.status || "");
      setRemarks(machine?.remarks);
      // setRemarksOptions([]);
      updateRemarks(machine?.status || "");
      setShowRemarksError(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxWidth: 400,
            bgcolor: 'white',
            boxShadow: 24,
            p: 4,
            borderRadius: 8,
            textAlign: 'center',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, marginBottom: 2 }}>
            Set Availability Status
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" sx={{ marginBottom: 2 }}>
            You're about to update the availability status for:
          </Typography>
          <Typography variant="h5" color="text.primary" sx={{ fontWeight: 600, marginBottom: 3 }}>
            {machine?.machine_id}
          </Typography>
          <FormControl component="fieldset" sx={{ mt: 3 }}>
            <FormLabel component="legend">Select New Status</FormLabel>
            <RadioGroup
              aria-label="status"
              name="status"
              value={(status !== "Available") ? "Not-available" : status}
              onChange={handleStatusChange}
              row
            >
              <FormControlLabel value="Available" control={<Radio />} label="Available" />
              <FormControlLabel value="Not-available" control={<Radio />} label="Not Available" />
            </RadioGroup>
          </FormControl>
          {(status !== "Available") && (
            <FormControl sx={{ mt: 3, width: '100%' }}>
              <InputLabel id="sub-status-label">Sub-Status</InputLabel>
              <Select
                labelId="sub-status-label"
                id="sub-status"
                value={subStatus}
                onChange={handleSubStatusChange}
                label="Sub-Status"
              >
                <MenuItem disabled value="In Use">In Use</MenuItem>
                <MenuItem value="Under Maintenance">Under Maintenance</MenuItem>
                <MenuItem value="Under Calibration">Under Calibration</MenuItem>
                <MenuItem value="Breakdown">In Breakdown</MenuItem>
              </Select>
            </FormControl>
          )}
          {(
            // subStatus === 'In Use' || subStatus === 'Breakdown'
            subStatus !== "Available"
          ) && (
              <>
                {
                  subStatus === "In Use" &&
                  <FormControl sx={{ mt: 3, width: '100%' }}>
                    <InputLabel id="remarks-label">Remarks</InputLabel>
                    <Select
                      labelId="remarks-label"
                      id="remarks"
                      value={remarks}
                      onChange={handleRemarksChange}
                      label="Remarks"
                    >
                      {remarksOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                }
                {subStatus === 'Breakdown' && (
                  <TextField
                    label="Additional Remarks (Required)"
                    multiline
                    rows={4}
                    fullWidth
                    value={remarks}
                    onChange={handleRemarksChange}
                    error={showRemarksError}
                    helperText={
                      showRemarksError ? 'Remarks are required for marking Machine Unavailability status.' : ''
                    }
                    sx={{ mt: 3 }}
                  />
                )}
              </>
            )}
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button variant="outlined" onClick={handleClose} sx={{ marginRight: 2 }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                backgroundColor: '#4caf50',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#45a049', // Change hover color
                },
              }}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default MachineAvailabilityModal;
